module.exports = __webpack_public_path__ + "img/top-gear-A-high_146x146.5b3dffc7.png";